module.exports = __webpack_public_path__ + "images/psp/Bicycle/5x5.svg";